import { apiService as Service } from '@/services/service'

const url = 'tos'

export const tosService = {
	loadCurrent: () =>
		Service.get({
			url: `${url}/current`,
		}),
	acceptCurrent: () =>
		Service.post({
			url: `${url}/current`,
		}),
	refuseCurrent: () =>
		Service.delete({
			url: `${url}/current`,
		}),
}

export default tosService
